import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../api/api";
import { Toast } from "../../utils/Toast";

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [contact, setContact] = useState(
    searchParams.get("phone") ||
    searchParams.get("email") ||
    searchParams.get("customer") ||
    ""
  );

  const campaignId = searchParams.get("campaignId") || "";

  const handleUnsubscribe = async () => {
    if (!contact?.trim()) {
      Toast.warning("Informe o contato para continuar.");
      return;
    }

    try {
      setLoading(true);

      await api.post("/campanha/unsubscribe", {
        phone: contact?.trim(),
        campaignId,
      });

      setSuccess(true);
      Toast.success("Descadastro realizado com sucesso.");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="card p-4" style={{ width: "100%", maxWidth: 500 }}>
        <h4 className="mb-3">Cancelar inscrição</h4>

        {success ? (
          <div className="alert alert-success mb-0">
            Você foi descadastrado com sucesso e não receberá mais mensagens desta campanha.
          </div>
        ) : (
          <>
            <p className="text-muted">
              Confirme o contato para cancelar o recebimento de mensagens.
            </p>

            <div className="mb-3">
              <label className="form-label">Contato (telefone ou e-mail)</label>
              <input
                className="form-control"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
                placeholder="Ex.: 11999999999"
              />
            </div>

            <button
              className="btn btn-danger w-100"
              onClick={handleUnsubscribe}
              disabled={loading}
            >
              {loading ? "Processando..." : "Confirmar"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
